/**
 * This function requires an initial state compatible to validate the form.
 * the state field object must contains for example: 
 *      name: {
 *          value: '',
 *          min: 1,
 *          max: 7,
 *          hasError: false,
 *          errorMessage: ''
 *      }
 * 
 * @param {Object} state - The State of the form.
 * @param {Function} dispatch - The dispatch function for the form.
 * @returns {Boolean} If the validation is valid return false otherwise true
 */
export default (state, dispatch) => {
    let hasError = false;
    for (let param in state) {
        if (state[param].min || state[param].max) {
            // Min Error
            if (state[param].min) {
                if (state[param].required) {
                    if (state[param].value.length < state[param].min) {
                        hasError = true;
                        dispatch({ type: 'ADD_ERROR', param: param, message: `Necesita al menos ${state[param].min} letras` });
                    }
                } else {
                    if (state[param].value.length < state[param].min && state[param].value.length !== 0) {
                        hasError = true;
                        dispatch({ type: 'ADD_ERROR', param: param, message: `Necesita al menos ${state[param].min} letras` });
                    }
                }
            }

            // Max Error
            if (state[param].max) {
                if (state[param].value.length > state[param].max) {
                    hasError = true;
                    dispatch({ type: 'ADD_ERROR', param: param, message: `Necesita ser menos de ${state[param].max} letras` });
                }
            }
        }

        // If it has a type
        if (state[param].type) {
            switch (state[param].type) {
                // Number Type
                case 'number':
                    if (Number.isNaN(state[param].value)) {
                        hasError = true;
                        dispatch({ type: 'ADD_ERROR', param: param, message: `Esta casilla debe ser un numero valido` });
                    }
                    break;

                // Date Type
                case 'date':
                    // If a date is not set
                    if (state[param].value.length === 0) {
                        hasError = true;
                        dispatch({ type: 'ADD_ERROR', param: param, message: `Por favor asigne una fecha.` });
                    } else {
                        // if the date is not valid
                        const time = new Date(state[param].value).getTime();
                        if (Number.isNaN(time)) {
                            hasError = true;
                            dispatch({ type: 'ADD_ERROR', param: param, message: `La fecha es invalida.` });
                        }
                    }
                    break;
                case 'verification':
                    // If is not the same as the parameter which need to be verified
                    if (state[param].value !== state[state[param].verifyParam].value) {
                        hasError = true;
                        dispatch({ type: 'ADD_ERROR', param: param, message: `No es identica.` });
                    }
                    break;
                default:
            }
        }

    }

    return hasError;
};